import { Term } from "Interfaces/BookResort";
import { GetCountriesResult } from "Interfaces/GetReservations";

export type ArrivingGuestInfoState = {
    isLoading: boolean;  
    countries: GetCountriesResult[];
    reservationResult: ReservationDetails;
    pageErrors: PageErrors;
    hasPageErrors: boolean;
    terms: Term[];
    apiLoading: boolean;
}

export type ReservationDetails = {
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    state: string;
    zipcode: string;
    country: string;
    email: string;
    phone: string;
    bonvoyNumber: string;
    guestNames: GuestName[];
    numOfGuests: number;
    checkInDate: string | Date;
    numOfNights: number;
    roomTypeDescription: string;
    reservationConfirmationNumber: string;
    resortName: string;
    resortLocation: string;
    guestRadioButton: GuestRadioButton[];
    originalPrimaryGuestInfo: PrimaryGuest | any;
    orignialGuestInfo: GuestName[];
    ownerStayOption?: string;
    intentToStay?: string;
}

export type PrimaryGuest = {
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    state: string;
    zipcode: string;
    country: string;
    email: string;
    phone: string;
    bonvoyNumber: string;
}

export type GuestRadioButton = {
    description: string;
    checked: boolean;
}

export type GuestName = {
    firstName: string;
    lastName: string;
    errors: {
        firstNameError: boolean;
        lastNameError: boolean;
    }
}

export enum PageErrorType {
    'apiError' = 'apiError',
    'addressError' = 'addressError',
    'cityError' = 'cityError',
    'stateError' = 'stateError',
    'zipError' = 'zipError',
    'countryError' = 'countryError',
    'emailError' = 'emailError',
    'phoneError' = 'phoneError',
    'phoneValidationError' = 'phoneValidationError',
    'bonvoyError' = 'bonvoyError',
    'bonvoyValidationError' = 'bonvoyValidationError',
    'tandcError' = 'tandcError',
    'additionalGuestsError' = 'additionalGuestsError',
    'firstNameError' = 'firstNameError',
    'lastNameError' = 'lastNameError',
    'apiSubmitError' = 'apiSubmitError',
    'langError' = 'langError'
};

export interface PageErrors {
    [PageErrorType.apiError] : {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.addressError] : {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.cityError] : {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.stateError] : {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.zipError] : {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.countryError] : {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.emailError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.phoneError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.phoneValidationError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.bonvoyError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.bonvoyValidationError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.tandcError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.additionalGuestsError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.firstNameError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.lastNameError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.apiSubmitError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.langError]: {
        message: string;
        isErrored: boolean;
    },
}

export enum Actions {
    SETDATA = 'SETDATA',
    ERROR = 'ERROR',
    ADDPRIMARYGUESTINFO = 'ADDPRIMARYGUESTINFO',
    PRIMARYGUESTINFOERROR = 'PRIMARYGUESTINFOERROR',
    TOGGLEPRIMARYINFOERROR = 'TOGGLEPRIMARYINFOERROR',
    ADDITIONALGUESTINFOMODIFY = 'ADDITIONALGUESTINFOMODIFY',
    ADDITIONALGUESTINFOMODIFYERROR = 'ADDITIONALGUESTINFOMODIFYERROR',
    REMOVEADDITIONALGUEST = 'REMOVEADDITIONALGUEST',
    ADDADDITIONALGUESTS = 'ADDADDITIONALGUESTS',
    TERMS = 'TERMS',
    SETRADIOBUTTON = 'SETRADIOBUTTON',
    RESETTERMS = 'RESETTERMS',
    API_LOADING = 'API_LOADING'
}

export type ArrivingGuestInfoAction = {
    type: Actions;
    payload: any;
}

export type GuestTerms = {
    resourceId: string;
    name: string;
    nodename: string;
    universalPropertyCode: any[];
    acknowledgementNeeded: string;
    description: string;
    versionNumber: string;
    versionId: string;
    priority: number;
}

//constants 
export const InitReservationDetails: ReservationDetails = {
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    email: "",
    phone: "",
    bonvoyNumber: "",
    guestNames: [],
    numOfGuests: 0,
    checkInDate: "",
    numOfNights: 0,
    roomTypeDescription: "",
    reservationConfirmationNumber: "",
    resortName: "" , 
    resortLocation: "",
    guestRadioButton: [],
    originalPrimaryGuestInfo: {},
    orignialGuestInfo:[],
}

export interface GuestProfileRequest {
    ownerFirstName: string,
    ownerLastName: string,
    confirmationNumber: string,
    ownerStayOption: string,
    primaryFirstName: string,
    primaryLastName: string,
    address1: string,
    address2: "",
    city: string,
    state: string,
    zipCode: string,
    country: string,
    email: string,
    contactNumber: string,
    marriottBonvoyNumber: string,
    orignialGuestInfo?: any[],
    newGuestInfo?: any[] | string,
    ownerId?: string,
    termsAndConditions?: string,
    eid?: string,
    reason?: string,
    intentToStay: string,
    checkInDate: any,
    resortName: string,
}
export interface GuestProfileResponse {
    success: string;
    requestId: string;
}

export const InitPageErrors: PageErrors = {
    [PageErrorType.apiError]: {
        message: "Sorry, something went wrong, please try again later or please contact Owner/Member Services",
        isErrored: false
    },
    [PageErrorType.addressError]: {
        message: "Address is mandatory",
        isErrored: false
    },
    [PageErrorType.cityError]: {
        message: "City is mandatory",
        isErrored: false
    },
    [PageErrorType.stateError]: {
        message: "State is mandatory",
        isErrored: false
    },
    [PageErrorType.zipError]: {
        message: "Please enter a valid postal code",
        isErrored: false
    },
    [PageErrorType.countryError]: {
        message: "Country is mandatory",
        isErrored: false
    },
    [PageErrorType.emailError]: {
        message: "Please enter a valid email",
        isErrored: false
    },
    [PageErrorType.phoneError]: {
        message: "Phone is mandatory",
        isErrored: false
    },
    [PageErrorType.bonvoyError]: {
        message: "Marriott bonvoy number is mandatory",
        isErrored: false
    },
    [PageErrorType.bonvoyValidationError]: {
        message: "Enter 9 digit Marriot Bonvoy Number without special characters",
        isErrored: false
    },
    [PageErrorType.phoneValidationError]: {
        message: "Enter 14 digit Phone Number without special characters",
        isErrored: false
    },
    [PageErrorType.tandcError]: {
        message: "Please select all terms and conditions",
        isErrored: false
    },
    [PageErrorType.additionalGuestsError]: {
        message: "Please fill complete details for additional guest names",
        isErrored: false
    },
    [PageErrorType.firstNameError]: {
        message: "Please enter valid first name",
        isErrored: false
    },
    [PageErrorType.lastNameError]: {
        message: "Please enter valid last name",
        isErrored: false
    },
    [PageErrorType.apiSubmitError]: {
        message: "Sorry, we are not able to process the request at this time, please try again",
        isErrored: false
    },
    [PageErrorType.langError]: {
        message: "The characters you entered do not match the expected input format or language.  Please make entries in English characters only.",
        isErrored: false
    },
};

export const InitState: ArrivingGuestInfoState = {
    isLoading: true,
    countries: [],
    reservationResult: InitReservationDetails,
    pageErrors: InitPageErrors,
    hasPageErrors: false,
    terms: [],
    apiLoading: false
};